import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import Collapse from 'react-collapse'
import { FormattedMessage } from 'sb-react-intl'
import { compose, constants } from 'common/helpers'

import resolvePostponed from 'decorators/resolvePostponed'

import QueueUpgradeSubscription from 'components/QueueUpgradeSubscription/QueueUpgradeSubscription'
import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import Queue from 'components/Queue/DefaultQueue/DefaultQueue'

import messages from './messages'
import s from './QueueContainer.scss'


class QueueContainer extends Component {

  static propTypes = {
    placement: PropTypes.string.isRequired,
    isSubscriptionUpgradable: PropTypes.bool,
    style: PropTypes.object,
  }

  static defaultProps = {
    isSubscriptionUpgradable: false,
    style: {},
  }

  constructor(props) {
    super(props)

    this.state = {
      isOpened: false,
    }

    this.closeButtonRef = createRef()
    this.openButtonRef  = createRef()
  }

  focusOnElement = (ref) => (
    requestAnimationFrame(() => {
      const { current: el } = ref

      if (el) {
        el.focus()
      }
    })
  )

  toggle = () => {
    const { isOpened } = this.state

    if (!isOpened) {
      this.focusOnElement(this.closeButtonRef)
    }
    else {
      this.focusOnElement(this.openButtonRef)
    }

    this.setState({
      isOpened: !isOpened,
    })
  }

  render() {
    const { isOpened } = this.state
    const { placement, isSubscriptionUpgradable } = this.props

    return (
      <div className={s.container}>
        <Collapse.UnmountClosed isOpened={isOpened}>
          <WidthContainer>
            <div className={s.header}>
              <FormattedMessage className={s.title} {...messages.myQueue} />
              <button
                className={s.close}
                onClick={this.toggle}
                tabIndex="0"
                type="button"
                ref={this.closeButtonRef}
              >
                <FormattedMessage className={s.closeTitle} {...messages.close} />
                <CloseIcon className={s.closeButton} isFocusable={false} dataTestId={constants.testIds.queue.closeButton} />
              </button>
            </div>
          </WidthContainer>
        </Collapse.UnmountClosed>

        <Collapse.Collapse
          className={s.queue}
          isOpened={isOpened}
        >
          <WidthContainer>
            <div className={s.queueContainer}>
              <Queue className={s.content} placement={placement} trackingNumberPlacement="queue" />
            </div>
            {
              isSubscriptionUpgradable && (
                <QueueUpgradeSubscription />
              )
            }
          </WidthContainer>
        </Collapse.Collapse>
        {
          !isOpened && (
            <FormattedMessage
              className={s.toggleButton}
              tag="button"
              type="button"
              tabIndex="0"
              _ref={this.openButtonRef}
              {...messages.openMyQueue}
              onClick={this.toggle}
              data-testid={constants.testIds.queue.openButton}
            />
          )
        }
      </div>
    )
  }
}


export default compose(
  connect({
    isSubscriptionUpgradable: 'models.subscription.isUpgradable',
  }),
  resolvePostponed({ isNotificationVisible: true }),
)(QueueContainer)
